module.exports = __webpack_public_path__ + "static/media/mobile.086dbcb7.png";